import { Star } from "lucide-react";

export const StarRating = ({ value = 0, count, size = 14, onChange, className = "" }) => {
  const interactive = typeof onChange === "function";
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          onClick={interactive ? () => onChange(i) : undefined}
          className={`${interactive ? "cursor-pointer" : ""} transition-transform ${interactive ? "hover:scale-110" : ""}`}
          style={{ width: size, height: size }}
          fill={i <= Math.round(value) ? "currentColor" : "none"}
          color={i <= Math.round(value) ? "#F4A261" : "#cbb9a3"}
        />
      ))}
      {count != null && <span className="text-xs text-muted-foreground ml-1">{value > 0 ? value : "—"} ({count})</span>}
    </span>
  );
};
